// Cardio subpage. Lifts the route list (with map drilldown) off the
// dashboard and puts it behind its own tab so the main page stays focused
// on strength training.

import { useEffect, useState } from 'react';
import { CardioRoutes } from '../components/CardioRoutes';
import { PageLayout } from '../components/ManageLayout';
import css from './Cardio.module.css';

interface Overview {
  totalCardioKm: number;
  totalCardioHours: number;
}

interface CardioRow {
  id: number;
  date: string;
  source: string;
  notes: string | null;
  active_exercise: string | null;
  started_at: number;
  ended_at: number | null;
  media_path: string;
  duration_sec: number | null;
  distance_m: number | null;
  speed_kmh: number | null;
  avg_hr_bpm: number | null;
  peak_hr_bpm: number | null;
  elevation_gain_m: number | null;
}

function fmt(n: number): string {
  return n.toLocaleString('en');
}

export function Cardio() {
  const [overview, setOverview] = useState<Overview | null>(null);
  const [rows, setRows] = useState<CardioRow[] | null>(null);

  useEffect(() => {
    fetch('/api/stats/overview')
      .then((r) => r.json())
      .then(setOverview)
      .catch(() => setOverview(null));
    fetch('/api/stats/cardio-sessions?limit=500')
      .then((r) => r.json())
      .then(setRows)
      .catch(() => setRows([]));
  }, []);

  return (
    <PageLayout title="Cardio">
      <section className={css.summary}>
        <div className={css.stat}>
          <div className={css.statLabel}>Total distance</div>
          <div className={css.statValue}>
            {overview ? `${fmt(overview.totalCardioKm)} km` : '…'}
          </div>
        </div>
        <div className={css.stat}>
          <div className={css.statLabel}>Total time</div>
          <div className={css.statValue}>
            {overview ? `${fmt(overview.totalCardioHours)} hr` : '…'}
          </div>
        </div>
        <div className={css.stat}>
          <div className={css.statLabel}>Sessions with routes</div>
          <div className={css.statValue}>{rows ? fmt(rows.length) : '…'}</div>
        </div>
      </section>

      <section className={css.section}>
        <h2 className={css.sectionTitle}>Routes</h2>
        {rows ? (
          rows.length > 0 ? (
            <CardioRoutes data={rows} />
          ) : (
            <p className={css.hint}>no cardio sessions with parseable routes yet.</p>
          )
        ) : (
          <p className={css.hint}>loading…</p>
        )}
      </section>
    </PageLayout>
  );
}
